module.exports = __webpack_public_path__ + "assets/img/culture_img4.eecb0ddb.png";